import api from '../services/Connection';
import AjaxApi from './ajaxApi';

export const login = new AjaxApi({
	requestType: 'LOGIN',
	url: api.Login,
	otherActionTypes: ['LOGIN_LOGOUT_SUCCESS'],

	logout: function (options) {
		return {
			type: 'LOGIN_LOGOUT_SUCCESS',
			options,
			receivedAt: Date.now()
		};
	},

	handlers: {
		SUCCESS: function (state, action, options) {
			return Object.assign({}, state, {
				isFetching: false,
				data: action.json,
				error: null
			});
		}
	},

	otherHandlers: {
		LOGOUT_SUCCESS: function (state, action, options) {
			return Object.assign({}, state, {
				isFetching: false,
				data: null,
				error: null
			});
		}
	}
});

export const formTask = new AjaxApi({
	requestType: 'TASK_FORM',
	url: api.TaskList
});
export const TASK_FORM_SUCCESS = 'TASK_FORM_SUCCESS';

export const formTaskAssignment = new AjaxApi({
	requestType: 'TASK_ASSIGNMENT_FORM',
	url: api.TaskAssignmentList
});
export const TASK_ASSIGNMENT_FORM_SUCCESS = 'TASK_ASSIGNMENT_FORM_SUCCESS';

export const formTaskType = new AjaxApi({
	requestType: 'TASK_TYPE_FORM',
	url: api.TaskTypeList
});
export const TASK_TYPE_FORM_SUCCESS = 'TASK_TYPE_FORM_SUCCESS';

export const formEquipment = new AjaxApi({
	requestType: 'EQUIPMENT_FORM',
	url: api.EquipmentList
});
export const EQUIPMENT_FORM_SUCCESS = 'EQUIPMENT_FORM_SUCCESS';

export const formUser = new AjaxApi({
	requestType: 'USER_FORM',
	url: api.User
});
 export const USER_FORM_SUCCESS = 'USER_FORM_SUCCESS';

export const formEquipmentType = new AjaxApi({
	requestType: 'EQUIPMENT_TYPE_FORM',
	url: api.EquipmentType
});
export const EQUIPMENT_TYPE_FORM_SUCCESS = 'EQUIPMENT_TYPE_FORM_SUCCESS';

export const listDashboard = new AjaxApi({
	requestType: 'DASHBOARD_LIST',
	url: api.EquipmentList
});
export const DASHBOARD_LIST_SUCCESS = 'DASHBOARD_LIST_SUCCESS';

export const formClient = new AjaxApi({
	requestType: 'CLIENT_FORM',
	url: api.Client
});
export const CLIENT_FORM_SUCCESS = 'CLIENT_FORM_SUCCESS';

export const infoCycle = new AjaxApi({
	requestType: 'CYCLE_INFO',
	url: api.CycleList
});
export const CYCLE_INFO_SUCCESS = 'CYCLE_INFO_SUCCESS';

export const formLookupType = new AjaxApi({
	requestType: 'LOOKUPTYPE_FORM',
	url: api.LookupType
});
export const LOOKUPTYPE_FORM_SUCCESS = 'LOOKUPTYPE_FORM_SUCCESS';

export const listLookupType = new AjaxApi({
	requestType: 'LOOKUPTYPE_LIST',
	url: api.LookupType
});
export const LOOKUPTYPE_LIST_SUCCESS = 'LOOKUPTYPE_LIST_SUCCESS';

export const formLookup = new AjaxApi({
	requestType: 'LOOKUP_FORM',
	url: api.Lookup
});
export const LOOKUP_FORM_SUCCESS = 'LOOKUP_FORM_SUCCESS';

export const listLookup = new AjaxApi({
	requestType: 'LOOKUP_LIST',
	url: api.Lookup
});
export const LOOKUP_LIST_SUCCESS = 'LOOKUP_LIST_SUCCESS';

export const formModel = new AjaxApi({
	requestType: 'MODEL_FORM',
	url: api.Model
});
export const MODEL_FORM_SUCCESS = 'MODEL_FORM_SUCCESS';

export const listTopFilter = new AjaxApi({
	requestType: 'TOP_FILTER_LIST',
	url: api.EquipmentList
});
export const TOP_FILTER_LIST_SUCCESS = 'TOP_FILTER_LIST_SUCCESS';

export const formIndicator = new AjaxApi({
	requestType: 'INDICATOR_FORM',
	url: api.Indicator
});
export const INDICATOR_FORM_SUCCESS = 'INDICATOR_FORM_SUCCESS';

export const formLotDetail = new AjaxApi({
	requestType: 'LOTDETAIL_FORM',
	url: api.LotDetail
});
export const LOTDETAIL_FORM_SUCCESS = 'LOTDETAIL_FORM_SUCCESS';

export const formRole = new AjaxApi({
	requestType: 'Role_FORM',
	url: api.Role
});
export const roleFormSuccess = 'Role_FORM_SUCCESS';

export const formReusableTestPack = new AjaxApi({
	requestType: 'ReusableTestPack_FORM',
	url: api.ReusableTestPack
});
export const reusableTestPackFormSuccess = 'ReusableTestPack_FORM_SUCCESS';

export const formHoliday = new AjaxApi({
	requestType: 'HOLIDAY_FORM',
	url: api.HolidayList
});
export const HOLIDAY_FORM_SUCCESS = 'HOLIDAY_FORM_SUCCESS';

export const listIncubatorCycle = new AjaxApi({
	requestType: 'INCUBATORCYCLE_LIST',
	url: api.IncubatorCycle
});
export const INCUBATORCYCLE_LIST_SUCCESS = 'INCUBATORCYCLE_LIST_SUCCESS';

export const listIncubatorCycleDetail = new AjaxApi({
	requestType: 'INCUBATORCYCLEDETAIL_LIST',
	url: api.IncubatorCycleDetail
});
export const INCUBATORCYCLEDETAIL_LIST_SUCCESS = 'INCUBATORCYCLEDETAIL_LIST_SUCCESS';

export const listIncubatorCycleDetailPending = new AjaxApi({
	requestType: 'INCUBATORCYCLEDETAILPENDING_LIST',
	url: api.IncubatorCycleDetail
});
export const INCUBATORCYCLEDETAILPENDING_LIST_SUCCESS = 'INCUBATORCYCLEDETAILPENDING_LIST_SUCCESS';

export const infoUser = new AjaxApi({
	requestType: 'USER_INFO',
	url: api.User
});
export const USER_INFO_SUCCESS = 'USER_INFO_SUCCESS';

export const infoUserProfile = new AjaxApi({
	requestType: 'USER_INFO_PROFILE',
	url: api.UserProfile
});
export const USER_INFO_PROFILE_SUCCESS = 'USER_INFO_PROFILE_SUCCESS';

export const formEndoScope = new AjaxApi({
	requestType: 'ENDOSCOPE_FORM',
	url: api.EndoScopeList
});
export const ENDOSCOPE_FORM_SUCCESS = 'ENDOSCOPE_FORM_SUCCESS';

export const listEndoScope = new AjaxApi({
	requestType: 'ENDOSCOPE_LIST',
	url: api.EndoScopeList
});
export const ENDOSCOPE_LIST_SUCCESS = 'ENDOSCOPE_LIST_SUCCESS';

export const formEndoScopeCode = new AjaxApi({
	requestType: 'ENDOSCOPECODE_FORM',
	url: api.EndoScopeCodeList
});
export const ENDOSCOPECODE_FORM_SUCCESS = 'ENDOSCOPECODE_FORM_SUCCESS';

export const listEndoScopeCode = new AjaxApi({
	requestType: 'ENDOSCOPECODE_LIST',
	url: api.EndoScopeCodeList
});
export const ENDOSCOPECODE_LIST_SUCCESS = 'ENDOSCOPECODE_LIST_SUCCESS';

export let formAuthorizedClients = new AjaxApi({
	requestType: 'AUTHORIZED_CLIENTS_FORM',
	url: api.ClientRequests
});

export const AUTHORIZED_CLIENTS_FORM_SUCCESS = 'AUTHORIZED_CLIENTS_FORM_SUCCESS';

export let formHospital = new AjaxApi({
	requestType: 'HOSPITAL_FORM',
	url: api.Hospital
});
export const HOSPITAL_FORM_SUCCESS = 'HOSPITAL_FORM_SUCCESS';

export let formTopicPermission = new AjaxApi({
	requestType: 'TOPIC_PERMISSION_FORM',
	url: api.TopicPermission
});

export const TOPIC_PERMISSION_FORM_SUCCESS = 'TOPIC_PERMISSION_FORM_SUCCESS';

export const formAssets = new AjaxApi({
	requestType: 'ASSETS_FORM',
	url: api.Assets
});

export const ASSETS_FORM_SUCCESS = 'ASSETS_FORM_SUCCESS';

export const formAssetsCode = new AjaxApi({
	requestType: 'ASSETS_CODE_FORM',
	url: api.AssetsCode
});

 export const ASSETS_CODE_FORM_SUCCESS = 'ASSETS_CODE_FORM_SUCCESS';

export const uploadDiagnosticsInfo = new AjaxApi({
	requestType: 'UPLOAD_DIAGNOSTICS_INFO',
	url: api.UploadDiagnosticsInfo
});

export const UPLOAD_CYCLE_XML_FILES_SUCCESS = 'UPLOAD_CYCLE_XML_FILES_SUCCESS';

export const uploadCycleInfo = new AjaxApi({
	requestType: 'UPLOAD_CYCLE_XML_FILES',
	url: api.UploadCycleFiles
});



export * from './auth';
export * from './i18n';
export * from './cycles';